export const HEM_COMMERCE_BASE_PATH = 'https://commerce.hem.com/api/v1';
// export const HEM_COMMERCE_BASE_PATH =
//   process.env.GATSBY_IS_DEV_HEM_COM === 'true'
//     ? 'https://hem-commerce-staging.herokuapp.com/api/v1'
//     : 'https://commerce.hem.com/api/v1';

export const SAMPLE_QUANTITY_CAP = 5;

export const IS_PREVIEW = process.env.GATSBY_IS_PREVIEW === 'true';
export const IS_PRODUCTION = process.env.GATSBY_IS_PRODUCTION === 'true';
export const IS_DEVELOPMENT = process.env.GATSBY_IS_PRODUCTION === 'false';

export enum RegionEnum {
  Eu = 'eu',
  Us = 'us',
  Ca = 'ca',
  Gb = 'uk',
}

const PUBLIC_SHOPIFY_DOMAIN = {
  'hemusa.myshopify.com': 'us.hem.com',
  'hemprousa.myshopify.com': 'us.pro.hem.com',
  'hemdesign.myshopify.com': 'eu.hem.com',
  'hemdesignpro.myshopify.com': 'eu.pro.hem.com',
  'hem-canada.myshopify.com': 'ca.hem.com',
  'hemprouk.myshopify.com': 'uk.pro.hem.com',
  // dev stores
  'dev-hem-us.myshopify.com': 'dev-hem-us.myshopify.com',
  'dev-hem-eu.myshopify.com': 'dev-hem-eu.myshopify.com',
  'dev-hem-pro-us.myshopify.com': 'dev-hem-pro-us.myshopify.com',
};

export const SHOPIFY_DOMAIN =
  // @ts-expect-error I'm possitive this is a string. Thank you TypeScript.
  PUBLIC_SHOPIFY_DOMAIN[process.env.GATSBY_SHOPIFY_STORE_URL];

export const REGION = process.env.GATSBY_REGION as RegionEnum;
export const IS_PRO = process.env.GATSBY_IS_PRO === 'true';

export const CYLINDO_CUSTOMER_ID = 6888;

export const SHOW_MTO_PROGRAM_PDF_FOR_FAMILIES = IS_PRO
  ? [
      'Bon Pouf',
      'Hai',
      'Hunk',
      'Kendo',
      'Kumo',
      'Koti',
      'Palo',
      'Palo Block',
      'Puffy',
      'Touchwood',
      'Udon',
    ]
  : [];

export const TYPESENSE_COLLECTION =
  process.env.GATSBY_TYPESENSE_COLLECTION ||
  process.env.GATSBY_REGION_REGION_DIFFERENTIATOR;

export const TYPESENSE_SEARCH_ADAPTER_CONFIG = {
  server: {
    // eslint-disable-next-line no-undef
    apiKey: process.env.GATSBY_TYPESENSE_SEARCH_KEY,
    nodes: [
      {
        // eslint-disable-next-line no-undef
        host: process.env.GATSBY_TYPESENSE_HOST,
        port: 443,
        protocol: 'https',
      },
    ],
    cacheSearchResultsForSeconds: 2 * 60, // 2 minutes
  },
  additionalSearchParameters: {
    sort_by: '_eval(inStock:true):desc,priority:desc',
    query_by: 'sku,productName,variantName,designer,tags',
    query_by_weights: '5,5,3,1,2',
    exclude_fields: 'embedding',
  },
};

export const TYPESENSE_CERTIFICATIONS_SEARCH_ADAPTER_CONFIG = {
  server: {
    // eslint-disable-next-line no-undef
    apiKey: process.env.GATSBY_TYPESENSE_SEARCH_KEY,
    nodes: [
      {
        // eslint-disable-next-line no-undef
        host: process.env.GATSBY_TYPESENSE_HOST,
        port: 443,
        protocol: 'https',
      },
    ],
    cacheSearchResultsForSeconds: 2 * 60, // 2 minutes
  },
  additionalSearchParameters: {
    query_by: 'certifications',
    sort_by: 'productName:asc,variantName:asc',
    exclude_fields: 'embedding',
  },
};

export enum AirtableStatus {
  ACTIVE = 'Active',
  EXPIRING = 'Expiring',
  INACTIVE = 'Inactive',
  PRE_ORDER = 'Pre-order',
  IN_DEVELOPMENT = 'In Development',
}
